<template>
  <modal-layout :openModal="editModal">
    <div class="bg-white rounded-lg w-1/4 relative">
      <spinner :loading="editLoading" />
      <div class="flex flex-col items-start p-4">
        <div class="flex items-center w-full">
          <div class="text-gray-900 font-bold text-lg">Edit pipeline</div>
          <div
            class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer"
            @click="() => closeModal()"
          >
            <close-icon />
          </div>
        </div>
        <div class="form-control w-full mt-2">
          <input
            ref="name"
            type="text"
            placeholder="Title"
            class="input input-bordered w-full mb-2 mt-2"
            required
            name="pipeline_name"
            v-model="pipeline_name"
          />
        </div>

        <hr class="w-full my-3" />
        <section class="w-full flex justify-center">
          <div class="mr-5">
            <button
              class="btn btn-primary btn-outline"
              @click="() => closeModal()"
            >
              cancel
            </button>
          </div>
          <div class="">
            <button class="btn btn-primary" @click="handleEditPipeline">
              Save
            </button>
          </div>
        </section>
      </div>
    </div>
  </modal-layout>
</template>

<script>
import utils from '@/services/utils';
import ModalLayout from '../../layouts/ModalLayout.vue';
import CloseIcon from '../icons/closeIcon.vue';
import Spinner from '@/components/spinner.vue';

export default {
  components: { ModalLayout, CloseIcon, Spinner },
  name: 'PipelineEditModal',
  props: ['editModal', 'closeModal', 'oldName'],
  data() {
    return {
      pipeline_name: '',
      editLoading: false,
    };
  },
  watch: {
    oldName() {
      if (this.oldName) {
        this.pipeline_name = JSON.parse(this.oldName).pipeline_name;
        return JSON.parse(this.oldName).pipeline_name;
      }
      return '';
    },
  },
  mount() {
    console.log(this.oldName, 'oldName');
  },
  methods: {
    async handleEditPipeline() {
      try {
        this.editLoading = true;
        await this.$store.dispatch('editPipeline', {
          pipelineName: this.pipeline_name,
        });
        await this.$store.dispatch('fetchPipelineData');
        this.editLoading = false;
        this.closeModal();
      } catch (error) {
        utils.setStatusMsg(this, error?.message || 'Something went wrong');
        this.editLoading = false;
        this.closeModal();
      }
    },
  },
};
</script>
